const getters = {
    getSaleList(state){
        return state.saleList;
    },
    getSale(state){
        return state.sale;
    },
    getDefaultPaymentMode(state) {
        return state.defaultPaymentModeId;
    },
    getSaleTransactions(state) {
        return state.saleTransactions;
    },
    getReceiptData(state) {
        return state.receiptData;
    }
    
}

export default getters;
